var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-tag",style:(_vm.tagStyle)},[(_vm.count)?_c('span',{staticClass:"status-count"},[_vm._v(_vm._s(_vm.count)+" ")]):_vm._e(),_c('span',{staticClass:"status-label"},[_vm._v(_vm._s(_vm.statusLabel))])])
}
var staticRenderFns = []

export { render, staticRenderFns }